<template>
  <div v-loading="loading" class="home-contract-detail">
    <action-bar>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate class="detail-plate">
      <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
    </common-bg-plate>
    <common-bg-plate class="other-plate">
      <el-tabs v-model="activeName">
        <el-tab-pane label="交易信息" name="txn">
          <txn-info></txn-info>
        </el-tab-pane>
        <el-tab-pane label="事件信息" name="event">
          <event-info></event-info>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import timeImg from '@/assets/images/tableIcon/time.png'
import nowVersionImg from '@/assets/images/tableIcon/now-version.png'
import contractNameImg from '@/assets/images/tableIcon/contract-name.png'
import createIdImg from '@/assets/images/tableIcon/create-id.png'
import createUserImg from '@/assets/images/tableIcon/create-user.png'

import txnInfo from './txnInfo'
import eventInfo from './eventInfo'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ContractDetail',
  components: {
    subscribeBlock,
    txnInfo,
    eventInfo
  },
  data() {
    return {
      activeName: 'txn',
      title1: '合约基本信息',
      tableCol1: [
        { label: '合约名称', icon: contractNameImg, value: 'name' },
        { label: '创建用户', icon: createUserImg, value: 'ContractOperator' },
        { label: '当前版本', icon: nowVersionImg, value: 'version' },
        { label: '创建交易id', icon: createIdImg, value: 'TxId' },
        { label: '创建时间', icon: timeImg, value: 'createAt' }
      ],
      list1: {
        blockHash: '',
        blockHeight: '',
        previewHash: '',
        time: ''
      },
      loading: true
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getList()
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getContractLists']),
    getList(offset = 1, limit = 10) {
      let params = {
        offset,
        limit,
        chainId: this.$store.state.home.chainCid,
        contractName: this.$route.query.contractName
      }
      this.getContractLists(params).then(res => {
        this.list1 = res.items[0]
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('home-contract-detail', (), ());
.home-contract-detail {
  @include adaptation(
    (
      --home-contract-basic-detail-min-height: 312px,
      --home-contract-other-detail-margin-top: 16px,
      --home-contract-detail-offset: 48px,
      --home-contract-other-detail-title-height: 63px,
      --home-contract-detail-item-height: 70px
    )
  );
  --home-contract-other-detail-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-contract-detail-offset) - var(--home-contract-basic-detail-min-height) -
      var(--home-contract-other-detail-margin-top)
  );
  --home-contract-other-detail-content-min-height: calc(
    var(--home-contract-other-detail-min-height) - var(--home-contract-other-detail-title-height)
  );
  .cbaas-detail-table {
    /deep/ {
      .detail-item {
        height: var(--home-contract-detail-item-height);
      }
    }
  }
  .common-bg-plate {
    &.detail-plate {
      min-height: var(--home-contract-basic-detail-min-height);
    }

    &.other-plate {
      margin-top: var(--home-contract-other-detail-margin-top);
      min-height: var(--home-contract-other-detail-min-height);

      .el-tabs {
        min-height: var(--home-contract-other-detail-min-height);

        /deep/ .el-tabs__content {
          min-height: var(--home-contract-other-detail-content-min-height);

          .el-empty {
            min-height: var(--home-contract-other-detail-content-min-height);
          }

          .normal-table-wrap {
            min-height: var(--home-contract-other-detail-content-min-height);

            .el-empty {
              min-height: var(--home-contract-other-detail-content-min-height);
            }

            .normal-table {
              min-height: var(--home-contract-other-detail-content-min-height);
            }
          }
        }
      }
    }
  }
}
</style>
